import loopCreate from '{dede:global.cfg_basehost/}/loopCreate.js';
import loopFix from '{dede:global.cfg_basehost/}/loopFix.js';
import loopDestroy from '{dede:global.cfg_basehost/}/loopDestroy.js';

export default {
  loopCreate,
  loopFix,
  loopDestroy,
};
